import { css, cx } from "@emotion/css"

import Image from "@p-ban/common/src/components/html/Image"
import useFocusVisible from "@p-ban/common/src/hooks/useFocusVisible"
import useHover from "@p-ban/common/src/hooks/useHover"

import COLOR_CODE from "../../../constant/color"

type Props = {
  prefixImageSrc?: string
} & JSX.IntrinsicElements["input"]

const CheckBox = ({ children, prefixImageSrc, checked = false, disabled = false, ...props }: Props) => {
  const { isHovered, hoverProps } = useHover()
  const { isFocusVisible, focusVisibleProps } = useFocusVisible()

  return (
    <label
      {...hoverProps}
      className={cx(styles.default, !disabled && isHovered && styles.hover, isFocusVisible && styles.focus)}
    >
      <input {...props} {...focusVisibleProps} checked={checked} disabled={disabled} type="checkbox" />
      {prefixImageSrc && <Image src={prefixImageSrc} alt="" />}
      {children}
    </label>
  )
}

export default CheckBox

const styles = {
  default: css`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 34px;
    padding: 0 12px;

    border: 1px solid ${COLOR_CODE.GREEN};
    border-radius: 4px;

    > input {
      outline: none;
    }
    > img {
      padding-left: 3px;
    }
  `,
  hover: css`
    opacity: 0.7;
  `,
  focus: css`
    outline: solid 2px ${COLOR_CODE.FOCUS_GRAY};
  `,
}
